// Association.Role — a named composition of capabilities.
//
// Flexible-entity migration step 4 + the F-D shortcut (§4). Roles are
// preset CODE CONSTANTS first: a fixed `ReadonlyMap<RoleId, Role>`
// seeded at `initial`, always present, reconstructible (the
// self-healing-defaults rule). The domain gates on CAPABILITIES, never
// role names, so landing admin-editable roles (step 6: DefineRole /
// AddCapabilityToRole events populating this same map) changes NO call
// site — it only makes the map dynamic.
export { fromId, mkRole, mkRoleId, mkRoleName, PRESET_ROLES, roleIdTo };
import { mkParser } from "../_ids/parse.js";
import * as Capability from "./capability.js";
const mkRoleId = (s) => s;
const roleIdTo = mkParser("RoleId", mkRoleId);
const fromId = (id) => id;
const mkRoleName = (s) => s;
const mkRole = (id, name, capabilities) => ({ id, name, capabilities });
// === Preset roles (code constants — the F-D shortcut) ===
//
// `admin` = every capability. `author` = full resource verbs + export +
// membership. `reviewer` = read + annotate. `viewer` = read only. The
// ids double as their stable string keys (`role:admin`, …).
const C = Capability.CAPABILITIES;
const ROLE_ADMIN = mkRoleId("role:admin");
const ROLE_AUTHOR = mkRoleId("role:author");
const ROLE_REVIEWER = mkRoleId("role:reviewer");
const ROLE_VIEWER = mkRoleId("role:viewer");
const adminRole = mkRole(ROLE_ADMIN, mkRoleName("Admin"), new Set([
    C.resourceRead,
    C.resourceEdit,
    C.resourceDelete,
    C.resourceDuplicate,
    C.scopeManageMembers,
    C.grantManage,
    C.roleDefine,
    C.packageExport,
    C.annotationCreate,
]));
const authorRole = mkRole(ROLE_AUTHOR, mkRoleName("Author"), new Set([
    C.resourceRead,
    C.resourceEdit,
    C.resourceDelete,
    C.resourceDuplicate,
    C.scopeManageMembers,
    C.packageExport,
    C.annotationCreate,
]));
const reviewerRole = mkRole(ROLE_REVIEWER, mkRoleName("Reviewer"), new Set([C.resourceRead, C.annotationCreate]));
const viewerRole = mkRole(ROLE_VIEWER, mkRoleName("Viewer"), new Set([C.resourceRead]));
const PRESET_ROLES = new Map([
    [ROLE_ADMIN, adminRole],
    [ROLE_AUTHOR, authorRole],
    [ROLE_REVIEWER, reviewerRole],
    [ROLE_VIEWER, viewerRole],
]);
// `roleIdTo` is re-exported (parse an untrusted role id at the
// boundary); nothing gates on the parse succeeding beyond id-shape —
// an unknown role simply grants no capabilities in `can`.
//# sourceMappingURL=role.js.map